$(function(){
    var headerHeight = $('header').height();
    $('[data-moveTo]').on('click', function(){
        var speed = 1000;
        var href= $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - headerHeight;
        $('html, body').animate({scrollTop:position}, speed, 'easeOutCubic');
        return false;
    });
});
$(window).on('load', function() {
    var headerHeight = ($(window).width() > 768)? $('header').height() : 0;
    var target = location.hash;
    if (target) {
        var position = $(target).offset().top - headerHeight - 40;
        $('html, body').animate({scrollTop:position}, 10, 'easeOutCubic');
        return false;
    }
});
